import type { ComponentPropsWithoutRef } from 'react'

type Props = ComponentPropsWithoutRef<'svg'>

export function EditIcon(props: Props) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="#1B1C1B" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M6.99902 17.0134L11.412 16.9984L21.044 7.45839C21.422 7.08039 21.63 6.57839 21.63 6.04439C21.63 5.51039 21.422 5.00839 21.044 4.63039L19.458 3.04439C18.702 2.28839 17.383 2.29239 16.633 3.04139L6.99902 12.5834V17.0134ZM18.044 4.45839L19.633 6.04139L18.036 7.62339L16.45 6.03839L18.044 4.45839ZM8.99902 13.4174L15.029 7.44439L16.615 9.03039L10.586 15.0014L8.99902 15.0064V13.4174Z" />
      <path d="M5 21H19C20.103 21 21 20.103 21 19V10.332L19 12.332V19H8.158C8.132 19 8.105 19.01 8.079 19.01C8.046 19.01 8.013 19.001 7.979 19H5V5H11.847L13.847 3H5C3.897 3 3 3.897 3 5V19C3 20.103 3.897 21 5 21Z" />
    </svg>
  )
}
